module.exports = __webpack_public_path__ + "static/008616-deef9f6a9585a74c201de7a03f1a66ab.jpg";